const INVALID_SCOOTER_NUMBER_MESSAGE = 'Неверный номер самоката';
export const VEHICLE_PROVIDER_MISMATCH_MESSAGE = 'Выбранное транспортное средство не относится к указанному провайдеру';

const INVALID_SCOOTER_BACKEND_MESSAGES = [
  'Vehicle not found',
  'Vehicle provider not found',
];
const PROVIDER_MISMATCH_BACKEND_MESSAGES = [
  'Vehicle does not belong to selected provider',
  VEHICLE_PROVIDER_MISMATCH_MESSAGE,
];

const getResponseMessages = value => {
  if (!value) {
    return [];
  }
  if (typeof value === 'string') {
    return [value];
  }
  if (Array.isArray(value)) {
    return value.flatMap(getResponseMessages);
  }
  if (typeof value === 'object') {
    return ['message', 'detail', 'error'].flatMap(key => getResponseMessages(value[key]));
  }
  return [];
};

export const normalizeCreateViolationError = response => {
  const messages = getResponseMessages(response).map(message => String(message).trim());
  if (messages.some(message => PROVIDER_MISMATCH_BACKEND_MESSAGES.includes(message))) {
    return {
      ...response,
      message: VEHICLE_PROVIDER_MISMATCH_MESSAGE,
      errors: {
        ...(response?.errors || {}),
        provider_id: [VEHICLE_PROVIDER_MISMATCH_MESSAGE],
      },
    };
  }

  if (!messages.some(message => INVALID_SCOOTER_BACKEND_MESSAGES.includes(message))) {
    return response;
  }

  return {
    ...response,
    message: INVALID_SCOOTER_NUMBER_MESSAGE,
    errors: {
      ...(response?.errors || {}),
      vehicle_id: [INVALID_SCOOTER_NUMBER_MESSAGE],
    },
  };
};
